'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.getGameCategory = void 0;
/**
 * Gets the primary game category
 * removing the default ones and returning the first of ones left
 * @param gameCategories
 * @param defaultCategories
 */
function getGameCategory(gameCategories, defaultCategories) {
    if (gameCategories === void 0) { gameCategories = []; }
    if (defaultCategories === void 0) { defaultCategories = []; }
    if (defaultCategories.length < 1 && gameCategories.length < 1) {
        throw new Error('there must be at least one category slug in any of the two arguments');
    }
    var filteredCats = gameCategories.filter(function (cat) { return !defaultCategories.includes(cat); });
    if (filteredCats.length) {
        return filteredCats[0];
    }
    return defaultCategories[0];
}
exports.getGameCategory = getGameCategory;
